<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
export default {
  components: { Main, Header },
  props: {
    height: { type: Number, default: 300 },
    scmCode: { type: String, default: '' },
    fabricExpenseCode: { type: String, default: '' },
    type: { type: String, default: 'radio' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  methods: {
    getData(form) {
      if (!this.scmCode) return
      this.loading = true
      this.$api
        .fabricExpenseChooseFabricListApi({
          scmCode: this.scmCode,
          fabricExpenseCode: this.fabricExpenseCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
  },
}
</script>
